<script>
import request from '@/found/utils/request';
import Form, { formCreate } from '@/found/components/form';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'terminal_record_flow_data_synchronism',
      buttonText: {
        submit: '确认',
      },
    };
  },

  methods: {
    // 设置rule
    setRule(v) {
      const item = v;
      return item;
    },
    // 表单渲染完成后调用
    formComplete() {},
    // 表单提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        request
          .get(
            '/cps/v1/terminalScanCodeRecordController/syncDateTerminalScanCode',
            formData,
          )
          .then((res) => {
            if (!res.success) return this.$message.error(res.message);
            this.$message.success('数据同步成功');
            this.$emit('onClose');
            this.$emit('onGetList');
          });
      }
    },
  },
};
</script>
